module.exports = __webpack_public_path__ + "img/av233.3b675092.png";